import Funcionalidades from '@/repositories/Funcionalidades';

// state
const state = () => ({
  blExibeLp: 0,
  funcionalidades: [],
  selecionado: {
    nome: '',
    texto: '',
    icone: ''
  },
  modo: 'funcionalidades'
});
  
// getters
const getters = {
  getBlExibeLp: (state) => {
    return state.blExibeLp;
  },
  getFuncionalidades: (state) => {
    return state.funcionalidades;
  },
  getSelecionado: (state) => {
    if (state.selecionado.nome != '') {
      return state.selecionado;
    }
    
    if (state.funcionalidades.length > 0) {
      return state.funcionalidades[0];
    }

    return state.selecionado;
  },
  getModo: (state) => {
    return state.modo;
  }
};
  
// mutations
const mutations = {
  SET_BL_EXIBE_LP (state, blExibeLp) {
    state.blExibeLp = blExibeLp;
  },
  SET_FUNCIONALIDADES (state, funcionalidades) {
    state.funcionalidades = funcionalidades;
  },
  SET_SELECIONADO (state, selecionado) {
    state.selecionado = selecionado;
  },
  SET_MODO (state, modo) {
    state.modo = modo;
  }
};

// actions
const actions = {
  setBlExibeLp ({ commit }, blExibeLp) {
    commit('SET_BL_EXIBE_LP', blExibeLp);
  },
  buscaFuncionalidades ({ commit }) {
    const dados = Funcionalidades.funcionalidades();

    if (!dados) {
      return;
    }

    commit('SET_FUNCIONALIDADES', dados);
  },
  updateNaoExibirLp () {
    Funcionalidades.updateNaoExibirLp();
  },
  setSelecionado ({ commit }, selecionado) {
    commit('SET_SELECIONADO', selecionado);
  },
  setModo ({ commit }, modo) {
    commit('SET_MODO', modo);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
  